import { render, staticRenderFns } from "./History_Index.vue?vue&type=template&id=1c5920f3&scoped=true"
import script from "./History_Index.vue?vue&type=script&lang=js"
export * from "./History_Index.vue?vue&type=script&lang=js"
import style0 from "./History_Index.vue?vue&type=style&index=0&id=1c5920f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5920f3",
  null
  
)

export default component.exports